const defaultTranslations = {
  yes: "Yes",
  no: "No",
  next: "Next",
  close: "Close",
  submit: "Submit",
  welcome: "Welcome",
  tryAgain: "Restart",
  dataProtection: "Data protection",
  toArticle: "To the article",
  result: "Result",
  quiz: "Quiz",
  raffle: "Raffle",
  thankYou: "Thank you for your participation!",
  participants: "Participants",
  confirmRegistration:
    "You received an email to confirm your registration. Please click on the link in the email to finish your registration.",
  registerAgain: "Participant Registration",
  registerNowCall: "Register now for free",
  showReadersChoice: "See readers' choice",
  showYourSelection: "Back to your selection",
  onlyWithRegistration: `You must be registered in order to save your data. Click on <b>"Submit selection"</b> to register <b>completely free</b> of charge.`,
  request: {
    pending: "Sending your request ...",
    error: "Your request has failed due to a technical error",
    success: "Request Sent",
  },
  registration: {
    next: "Next Step",
    submit: "Send and Participate",
    required: "Required",
    welcome: "Welcome",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Your email address",
    male: "Mr.",
    female: "Mrs.",
    street: "Street",
    houseNumber: "House Nr.",
    postalcode: "Postal Code",
    city: "City",
    telephone: "Phone",
    startInfo:
      "Please enter your personal details in order to take part in the competition.",
    prizeInfo: "Please fill in your address for the prize notification.",
    termsAndConditions: (link: string) =>
      `By sending your data you are agreeing to the <a href="${link}" target="_blank">Terms and Conditions</a>.`,
    privacy: "Notes on data-usage policy",
    advertisementOptInLabelAS: (link: string) =>
      `Ja, ich möchte, dass die Axel Springer Deutschland GmbH mir Newsletter per E-Mail und/oder Push-Nachrichten mit Produktangeboten
und/oder Medienangeboten der Axel Springer Medien zuschickt. Meine Einwilligung kann ich jederzeit
<a href="${link}" target="_blank">widerrufen</a>.`,
    advertisementOptInLabelAS2: (link: string) =>
      `Meine E-Mail-Adresse darf zum Zwecke des Retargeting in pseudonymisierter Form mit E-Mail-Adressen von Werbepartnern des Vermarkters der Axel Springer Deutschland GmbH abgeglichen werden, wenn ich dem jeweiligen Werbepartner ebenfalls meine Einwilligung (z.B. auf dessen Website) hierfür erteilt habe und kein Pur-Abo abgeschlossen habe. Meine Einwilligung kann ich jederzeit unter dem Link „Widerruf Nutzerkennungen“ durch Widerruf "Axel Springer Nutzerkennung" am Ende der Website widerrufen. Weitere Informationen in der <a href="${link}" target="_blank">Datenschutzerklärung</a>.`,
  },
  questionOutro: {
    advertisementOptInLabelAS: (link: string) =>
      `Die Tatsache meiner Teilnahme an dieser Umfrage sowie die von mir gegebenen Antworten dürfen für Zwecke personalisierter Werbung genutzt und in pseudonymisierter Form an Media Impact Vermarktungspartner weitergegeben werden. Meine Einwilligung kann ich jederzeit mit einem Klick auf den Link "Widerruf Nutzerkennungen" im Footer der Website widerrufen. Nähere Informationen finde ich <a href="${link}" target="_blank">hier</a>.`,
  },
  score: {
    title: "Correct answers",
    retry: "Restart",
  },
  answerSlide: {
    correctAnswer: "This is correct!",
    wrongAnswer: "Wrong!",
    next: "Next",
  },
  pollSummary: {
    title: "Summary of all Votes",
    resultText: "voted like you",
  },
  quizSummary: {
    title: "Evaluation of your answers",
    resultText: "Correct Answers",
  },
  secretSummary: {
    defaultText: "The result of the poll will be published at a later date.",
    defaultTextWithEndDate: (dateString: string) =>
      `The result of the poll will be published on ${dateString}.`,
    surveyEndedTitle: "The survey is finished!",
    surveyEndedMessage:
      "Unfortunately, participation in this survey is no longer possible. Thank you very much for your interest.",
  },
  endedPoll: "The vote has already ended.",
  endedVoting: "The vote has already ended.",
  question: "Question",
  quizEndedIntro: {
    title: (quizType: string) => `${quizType} finished`,
    text: (quizType: string, date: string, time: string) =>
      `The ${quizType} ended on ${date} at ${time}. Unfortunately, participation is currently not possible.`,
  },
  quizFutureIntro: {
    title: (quizType: string) => `${quizType} not yet started`,
    text: (quizType: string, date: string, time: string) =>
      `The ${quizType} starts on ${date} at ${time}. Participation is possible from this point on.`,
  },
  yourSelection: "Your Selection",
  submitSelection: "Submit Selection",
  votingOverlay: (count: number) =>
    `Please select\n#${count}\nmore ${count === 1 ? "option" : "options"}`,
  imageCopyright: "Image copyrights",
  source: "Source",
  pollMultipleChoiceLabel: "Choose as many options as you want",
};

export type Translations = typeof defaultTranslations;

const germanTranslations: Translations = {
  ...defaultTranslations,
  yes: "Ja",
  no: "Nein",
  next: "Weiter",
  close: "Schliessen",
  submit: "Absenden",
  tryAgain: "Neu starten",
  result: "Ergebnis",
  quiz: "Quiz",
  dataProtection: "Datenschutz",
  toArticle: "Zum Artikel",
  raffle: "Gewinnspiel",
  thankYou: "Vielen Dank für Ihre Teilnahme!",
  participants: "Teilnehmer",
  confirmRegistration:
    "Es wurde eine E-Mail zur Bestätigung Ihrer Registrierung an die angegebene Adresse versandt. Um die Registrierung abzuschließen, klicken Sie bitte auf den Link in der E-Mail.",
  registerAgain: "Teilnehmerregistrierung",
  registerNowCall: "Jetzt kostenlos registrieren",
  showReadersChoice: "Leser-Auswahl ansehen",
  showYourSelection: "Zurück zu Deiner Auswahl",
  onlyWithRegistration: `Um Ihre Angaben speichern zu können, müssen Sie registriert sein. Klicken Sie auf <b>„Auswahl speichern“</b>, um sich <b>völlig kostenlos</b> zu registrieren.`,
  request: {
    pending: "Anfrage wird versendet ...",
    error: "Ihre Anfrage ist aufgrund eines technischen Fehlers fehlgeschlagen",
    success: "Anfrage gesendet",
  },
  registration: {
    next: "Weiter zur Anschrift",
    submit: "Absenden und Teilnehmen",
    required: "Pflichtfeld",
    welcome: "Willkommen",
    firstName: "Vorname",
    lastName: "Nachname",
    email: "Ihre E-Mail-Adresse",
    male: "Herr",
    female: "Frau",
    street: "Straße",
    houseNumber: "Haus Nr.",
    postalcode: "Postleitzahl",
    city: "Stadt",
    telephone: "Telefon",
    startInfo:
      "Bitte machen Sie noch Angaben zu Ihrer Person, um am Gewinnspiel teilnehmen zu können.",
    prizeInfo:
      "Bitte ergänzen Sie noch Ihre Adresse für die Gewinnbenachrichtigung.",
    termsAndConditions: (link: string) =>
      `Bei Absendung Ihrer Daten erklären Sie sich mit den <a href="${link}" target="_blank">Teilnahmebedingungen</a> einverstanden.`,
    privacy: "Hinweise zur Datennutzung",
    advertisementOptInLabelAS: (link: string) =>
      `Ja, ich möchte, dass die Axel Springer Deutschland GmbH mir Newsletter per E-Mail und/oder Push-Nachrichten mit Produktangeboten
und/oder Medienangeboten der Axel Springer Medien zuschickt. Meine Einwilligung kann ich jederzeit
<a href="${link}" target="_blank">widerrufen</a>.`,
    advertisementOptInLabelAS2: (link: string) =>
      `Meine E-Mail-Adresse darf zum Zwecke des Retargeting in pseudonymisierter Form mit E-Mail-Adressen von Werbepartnern des Vermarkters der Axel Springer Deutschland GmbH abgeglichen werden, wenn ich dem jeweiligen Werbepartner ebenfalls meine Einwilligung (z.B. auf dessen Website) hierfür erteilt habe und kein Pur-Abo abgeschlossen habe. Meine Einwilligung kann ich jederzeit unter dem Link „Widerruf Nutzerkennungen“ durch Widerruf "Axel Springer Nutzerkennung" am Ende der Website widerrufen. Weitere Informationen in der <a href="${link}" target="_blank">Datenschutzerklärung</a>.`,
  },
  questionOutro: {
    advertisementOptInLabelAS: (link: string) =>
      `Die Tatsache meiner Teilnahme an dieser Umfrage sowie die von mir gegebenen Antworten dürfen für Zwecke personalisierter Werbung genutzt und in pseudonymisierter Form an Media Impact Vermarktungspartner weitergegeben werden. Meine Einwilligung kann ich jederzeit mit einem Klick auf den Link "Widerruf Nutzerkennungen" im Footer der Website widerrufen. Nähere Informationen finde ich <a href="${link}" target="_blank">hier</a>.`,
  },
  score: {
    title: "Antworten richtig",
    retry: "Neu starten",
  },
  answerSlide: {
    correctAnswer: "Das ist richtig!",
    wrongAnswer: "Leider falsch!",
    next: "Weiter",
  },
  pollSummary: {
    title: "Übereinstimmung mit allen Abstimmenden",
    resultText: "stimmten wie Sie",
  },
  quizSummary: {
    title: "Auswertung Ihrer Antworten",
    resultText: "Antworten richtig",
  },
  secretSummary: {
    defaultText:
      "Das Ergebnis der Umfrage wird zu einem späteren Zeitpunkt veröffentlicht.",
    defaultTextWithEndDate: (dateString: string) =>
      `Das Ergebnis der Umfrage wird am ${dateString} veröffentlicht.`,
    surveyEndedTitle: "Die Umfrage ist beendet!",
    surveyEndedMessage:
      "Eine Teilnahme an der Umfrage ist leider nicht mehr möglich. Vielen Dank für das Interesse.",
  },
  endedPoll: "Die Abstimmung wurde bereits beendet.",
  endedVoting: "Die Abstimmung wurde bereits beendet.",
  question: "Frage",
  quizEndedIntro: {
    title: (quizType: string) => `${quizType} beendet`,
    text: (quizType: string, date: string, time: string) =>
      `Das ${quizType} ist am ${date} um ${time} abgelaufen. Eine Teilnahme ist im Moment leider nicht möglich.`,
  },
  quizFutureIntro: {
    title: (quizType: string) => `${quizType} noch nicht gestartet`,
    text: (quizType: string, date: string, time: string) =>
      `Das ${quizType} startet am ${date} um ${time}. Eine Teilnahme ist ab diesem Zeitpunkt möglich.`,
  },
  yourSelection: "Ihre Auswahl",
  submitSelection: "Auswahl Speichern",
  votingOverlay: (count: number) => `Bitte noch\n#${count}\nauswählen`,
  imageCopyright: "Bildrechte",
  source: "Quelle",
  pollMultipleChoiceLabel: "Wählen Sie beliebig viele Möglichkeiten aus",
};

const polishTranslations: Translations = {
  ...defaultTranslations,
  yes: "Tak",
  no: "Nie",
  next: "Dalej",
  close: "Zamknij",
  submit: "Wyślij",
  tryAgain: "Spróbuj ponownie",
  result: "Wynik",
  quiz: "Quiz",
  dataProtection: "Ochrona danych",
  toArticle: "Do artykułu",
  raffle: "Losowanie",
  thankYou: "Dziękujemy za udział!",
  participants: "Uczestnicy",
  confirmRegistration:
    "Wysłano e-mail w celu potwierdzenia Twojej rejestracji na podany adres. Aby zakończyć rejestrację, kliknij link w e-mailu.",
  registerAgain: "Rejestracja uczestnika",
  registerNowCall: "Zarejestruj się teraz za darmo",
  showReadersChoice: "Pokaż wybór czytelników",
  showYourSelection: "Powróć do swojego wyboru",
  onlyWithRegistration: `Aby zapisać swoje dane, musisz być zarejestrowany. Kliknij <b>„Zapisz wybór"</b>, aby zarejestrować się <b>zupełnie za darmo</b>.`,
  request: {
    pending: "Wysyłanie zapytania ...",
    error: "Twoje zapytanie nie powiodło się z powodu błędu technicznego",
    success: "Zapytanie wysłane",
  },
  registration: {
    next: "Dalej do adresu",
    submit: "Wyślij i weź udział",
    required: "Pole wymagane",
    welcome: "Witaj",
    firstName: "Imię",
    lastName: "Nazwisko",
    email: "Twój adres e-mail",
    male: "Pan",
    female: "Pani",
    street: "Ulica",
    houseNumber: "Numer domu",
    postalcode: "Kod pocztowy",
    city: "Miasto",
    telephone: "Telefon",
    startInfo:
      "Proszę podać jeszcze kilka danych, aby wziąć udział w losowaniu.",
    prizeInfo: "Proszę uzupełnić swój adres do powiadomienia o wygranej.",
    termsAndConditions: (link: string) =>
      `Wysyłając swoje dane, wyrażasz zgodę na <a href="${link}" target="_blank">warunki uczestnictwa</a>.`,
    privacy: "Informacje o przetwarzaniu danych",
    advertisementOptInLabelAS: (link: string) =>
      `Tak, chcę, aby Axel Springer Deutschland GmbH wysyłało mi newslettery e-mailem i/lub powiadomienia push z ofertami produktów
i/lub ofertami mediów Axel Springer. Mogę w każdej chwili
<a href="${link}" target="_blank">cofnąć zgodę</a>.`,
    advertisementOptInLabelAS2: (link: string) =>
      `Mój adres e-mail może być wykorzystywany do celów retargetingu w pseudonimizowanej formie i porównywany z adresami e-mail partnerów reklamowych Axel Springer Deutschland GmbH, jeśli wyraziłem zgodę na tej stronie internetowej i nie mam aktywnej subskrypcji Pur. Zgodę mogę w każdej chwili wycofać, klikając „Cofnij identyfikatory użytkowników” na dole strony. Więcej informacji w <a href="${link}" target="_blank">polityce prywatności</a>.`,
  },
  questionOutro: {
    advertisementOptInLabelAS: (link: string) =>
      `Fakt mojego udziału w badaniu oraz moje odpowiedzi mogą być wykorzystywane do celów personalizowanej reklamy i przekazywane w pseudonimizowanej formie partnerom marketingowym Media Impact. Zgodę mogę w każdej chwili wycofać klikając link "Cofnij identyfikatory użytkowników" w stopce strony. Więcej informacji znajdę <a href="${link}" target="_blank">tutaj</a>.`,
  },
  score: {
    title: "Poprawne odpowiedzi",
    retry: "Spróbuj ponownie",
  },
  answerSlide: {
    correctAnswer: "To jest poprawne!",
    wrongAnswer: "Niestety, to błędne!",
    next: "Dalej",
  },
  pollSummary: {
    title: "Zgodność z wszystkimi głosującymi",
    resultText: "głosowali tak jak Ty",
  },
  quizSummary: {
    title: "Ocena Twoich odpowiedzi",
    resultText: "Poprawne odpowiedzi",
  },
  secretSummary: {
    defaultText: "Wynik ankiety zostanie opublikowany w późniejszym terminie.",
    defaultTextWithEndDate: (dateString: string) =>
      `Wynik ankiety zostanie opublikowany ${dateString}.`,
    surveyEndedTitle: "Ankieta zakończona!",
    surveyEndedMessage:
      "Niestety, udział w ankiecie nie jest już możliwy. Dziękujemy za zainteresowanie.",
  },
  endedPoll: "Głosowanie zostało już zakończone.",
  endedVoting: "Głosowanie zostało już zakończone.",
  question: "Pytanie",
  quizEndedIntro: {
    title: (quizType: string) => `${quizType} zakończony`,
    text: (quizType: string, date: string, time: string) =>
      `${quizType} zakończył się ${date} o ${time}. Udział jest teraz niemożliwy.`,
  },
  quizFutureIntro: {
    title: (quizType: string) => `${quizType} jeszcze się nie rozpoczęło`,
    text: (quizType: string, date: string, time: string) =>
      `${quizType} rozpocznie się ${date} o ${time}. Udział będzie możliwy od tego momentu.`,
  },
  yourSelection: "Twój wybór",
  submitSelection: "Zapisz wybór",
  votingOverlay: (count: number) => `Proszę wybrać jeszcze\n#${count}`,
  imageCopyright: "Prawa autorskie do zdjęcia",
  source: "Źródło",
  pollMultipleChoiceLabel: "Wybierz dowolną liczbę opcji",
};

// @see https://developer.mozilla.org/en-US/docs/Mozilla/Add-ons/WebExtensions/Internationalization
export default {
  en_US: defaultTranslations,
  de_DE: germanTranslations,
  pl_PL: polishTranslations,
};
